import { STAMMDATEN_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { useHasPermission } from '@Contexts/appContext';
import { type ApiRentVariant } from '@Model';
import {
    FrameFallback,
    type IFrameEditShellProps,
    useEditFrame,
    useFrameEditBaseNavigation,
} from '@synqo/frontend-component-library';
import { useMemo } from 'react';
import { useParams } from 'react-router';
import { RentVariantFrameBody } from './RentVariant/RentVariantFrameBody';

// @ai-generated 2026-10-21T09:12:12+00:00 by malte.ulfers@tngtech.com using Claude Opus 5.5 (1M context)

export function FrameEditRentVariant(props: IFrameEditShellProps<ApiRentVariant>) {
    const { itemId } = useParams();
    const primaryKey = props.primaryKey ?? itemId ?? '';

    return (
        <RentVariantEditFrame
            key={primaryKey}
            {...props}
            primaryKey={primaryKey}
            embedded={props.embedded || props.primaryKey !== undefined}
        />
    );
}

// @ai-generated 2026-10-21T10:02:26+00:00 by malte.ulfers@tngtech.com using Claude Opus 5.5 (1M context)

function RentVariantEditFrame(props: IFrameEditShellProps<ApiRentVariant> & { primaryKey: string }) {
    const hasPermission = useHasPermission();

    const frameEditBaseNavigationEvents = useFrameEditBaseNavigation();

    const events = useMemo(
        () => ({
            ...frameEditBaseNavigationEvents,
            ...props.events,
        }),
        [frameEditBaseNavigationEvents, props.events],
    );

    const frame = useEditFrame<ApiRentVariant>({
        apiResourcePath: `${STAMMDATEN_API}/rent_variants`,
        primaryKey: props.primaryKey,
        embedded: props.embedded,
        events,
        canEdit: props.canEdit !== false && hasPermission(Permission.StammdatenRentVariantUpdate),
        canCreate: props.canCreate !== false && hasPermission(Permission.StammdatenRentVariantCreate),
        canDelete: props.canDelete !== false && hasPermission(Permission.StammdatenRentVariantDelete),
    });

    if (frame.status !== 'ready') {
        return <FrameFallback frame={frame} />;
    }

    return <RentVariantFrameBody key={frame.recordId} frame={frame} />;
}
